import React from "react";
import PropTypes from "prop-types";

function InputSingle(props) {
  function renderIcon(params) {
    if (!!props.icon) return <props.icon className="w-4 h-4 mx-2" />;

    return null;
  }
  return (
    <div className={`flex flex-row p-2 bg-gray-200 dark:bg-gray-600 rounded-lg items-center ${props.className ?? ""}`}>
      {renderIcon()}
      <input
        value={props.value ?? null}
        // value="anjir"
        disabled={props.disable ?? false}
        type={props.type ?? "text"}
        placeholder={props.placeholder ?? ""}
        className="bg-gray-200 text-gray-600 dark:text-white dark:bg-gray-600 w-full"
        onChange={(e) => {
          props.onChange(e);
        }}
        id={props.id}
        
      />
    </div>
  );
}

InputSingle.defaultProps = {
  onChange: function onChange(params) {
    return null;
  },
};

InputSingle.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.element,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  disable: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
};

export default InputSingle;
